import * as React from "react";
import { toast } from "sonner";

const WARN_RATIO = 0.85;
const DISMISS_KEY = "pwa-storage-quota-warned";

/** Warn once when IndexedDB / Cache storage is near quota (mobile Safari). */
export function useStorageQuotaWarning(): void {
  React.useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        if (!navigator.storage?.estimate) return;
        if (localStorage.getItem(DISMISS_KEY) === "1") return;
        const { usage = 0, quota = 0 } = await navigator.storage.estimate();
        if (cancelled || !quota || usage / quota < WARN_RATIO) return;
        localStorage.setItem(DISMISS_KEY, "1");
        toast.message("Az eszköz tárhelye majdnem tele van", {
          description: "Az offline gyorsítótár korlátozott lehet. Szabadíts fel helyet a megbízhatóbb offline használathoz."
        });
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
}
